import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

import React, { useEffect, useState } from "react";
import { useGetPursuit } from "./useGetPursuit";
import { useGetPursuitTask } from "./task/useGetPursuitTask";
import { toPascalCase, truncateStringToMaxWords } from "@/utils/helpers";
import { Route } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function PursuitMainLayout(props) {
  const location = useLocation();
  const { pursuit_id, task_id } = useParams();
  const { data: pursuit, isLoading: isPursuitLoading } =
    useGetPursuit(pursuit_id);
  const { data: task, isLoading: isTaskLoading } = useGetPursuitTask(task_id);
  const pathnames = location.pathname.split("/").filter((x) => x);

  const [names, setNames] = useState({});

  useEffect(() => {
    const namesMap = {};
    pathnames.forEach((id) => {
      if (id === pursuit_id) {
        namesMap[id] = isPursuitLoading ? (
          <span className="text-muted-foreground/50">Loading...</span>
        ) : (
          truncateStringToMaxWords(pursuit?.title || id, 10)
        );
      } else if (id === task_id) {
        namesMap[id] = isTaskLoading ? (
          <span className="text-muted-foreground/50">Loading...</span>
        ) : (
          truncateStringToMaxWords(task?.title || id, 10)
        );
      } else {
        namesMap[id] = toPascalCase(id); // Fallback to id if name is not found
      }
    });
    setNames(namesMap);
  }, [
    pursuit_id,
    pursuit?.title,
    task_id,
    task?.title,
    isPursuitLoading,
    isTaskLoading,
  ]); // queryClient removed from dependencies
  return (
    <main className="flex-1 flex flex-col">
      {/* Header */}
      <header className="border-b border-border p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Breadcrumb>
              <BreadcrumbList>
                {pathnames.map((value, index) => {
                  const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                  if (index < pathnames.length - 1)
                    return (
                      <React.Fragment key={to}>
                        <BreadcrumbItem>
                          <BreadcrumbLink asChild>
                            <NavLink to={to}>
                              {index === 0 ? (
                                <span className="text-xl flex items-center gap-2">
                                  <span className="bg-muted/70 rounded-md p-1">
                                    <Route className="h-4 w-4 text-muted-foreground/50 " />
                                  </span>
                                  Journey Hub
                                </span>
                              ) : (
                                names[value] || toPascalCase(value)
                              )}
                            </NavLink>
                          </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                      </React.Fragment>
                    );
                  else
                    return (
                      <BreadcrumbItem key={to}>
                        <BreadcrumbPage>
                          {" "}
                          {index === 0 ? (
                            <span className="flex items-center gap-2">
                              <span className="bg-muted/70 rounded-md p-1">
                                <Route className="h-4 w-4 text-primary/70 " />
                              </span>
                              <span className="text-xl font-semibold ">
                                Journey Hub{" "}
                              </span>
                              <Badge variant="secondary" className="rounded-md border border-muted bg-transparent">Beta</Badge>
                            </span>
                          ) : (
                            names[value] || toPascalCase(value)
                          )}
                        </BreadcrumbPage>
                      </BreadcrumbItem>
                    );
                })}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </div>
      </header>
      <div className="h-[calc(100vh-4rem)] overflow-y-scroll">
        <Outlet />
      </div>
    </main>
  );
}
